export default {
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    lots_info: [
        {id: -1, name: 'DETALLADO POR LOTES'},
        {id: -2, name: 'CONSOLIDADO'},
    ],
    branchOffices: [],
    branchoffice_warehouses: [],
    lines: [],
    brands: [],
    preloader: false,
    loading: {
        module:false,
    },
    params: {
        date: new Date(),
        branchoffice_id: -1,
        branchoffice_warehouse_id: null,
        line_id: null,
        brand_id: null,
        info_lots_id: -1,
        download: null
    },
    data_report:[]
};



// WEBPACK FOOTER //
// ./src/modules/inventory-report-wms/state.js